import { render, staticRenderFns } from "./menuApp.vue?vue&type=template&id=5bad849a&scoped=true"
import script from "./menuApp.vue?vue&type=script&lang=js"
export * from "./menuApp.vue?vue&type=script&lang=js"
import style1 from "./menuApp.vue?vue&type=style&index=1&id=5bad849a&prod&scoped=true&lang=css"
import style2 from "./menuApp.vue?vue&type=style&index=2&id=5bad849a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad849a",
  null
  
)

export default component.exports